// extracted by mini-css-extract-plugin
module.exports = {"authAdvertisingBanner":"AdvertisingBanner_authAdvertisingBanner__OTDN_"};